export const careerLevels = [
    { label: "Manager", value: "manager" },
    { label: "Experienced", value: "experienced" },
    { label: "Senior level", value: "senior-level" },
    { label: "Entry level", value: "entry-level" },
    { label: "Student", value: "student" },
  ];